export const BOOKING_URL = "https://indianheritagegalleryandculturalcentre.com/";
export const MAPS_DIRECTIONS =
    "https://www.google.com/maps/search/?api=1&query=Indian+Heritage+Cultural+Centre+57+Lebuh+Pantai+George+Town+Penang";
export const MAPS_EMBED =
    "https://www.google.com/maps?q=Indian%20Heritage%20Cultural%20Centre%2C%2057%20Lebuh%20Pantai%2C%20George%20Town%2C%20Penang%2C%20Malaysia&output=embed";

export const WHATSAPP_URL =
    "https://chat.whatsapp.com/GuZrJatvCzA1RlRz9Yga8A?s=cl&p=i&mlu=4&ilr=4";

export const IMG = {
    hero: "/images/ihcc-heritage-shophouse-facade-night-george-town-penang.webp",
    mural: "/images/ihcc-gallery-hand-painted-elephant-mural-heritage-tiles.webp",
    lanterns: "/images/ihcc-heritage-gallery-vintage-glass-lanterns-interior.webp",
    artefacts: "/images/ihcc-traditional-indian-artefacts-vintage-lamps-display.webp",
    facadeAngle: "/images/ihcc-heritage-shophouse-lebuh-pantai-george-town.webp",
    sari: "/images/ihcc-sari-traditional-dress-up-experience-penang.webp",
    history: "/images/ihcc-penang-indian-history-gallery-portraits.webp",
    technology: "/images/ihcc-vintage-technology-sewing-machine-everyday-objects.webp",
    shop: "/images/ihcc-vintage-shop-memorabilia-souvenirs-penang.webp",
    nagarathar: "/images/ihcc-nagarathar-heritage-room-chandelier.webp",
};

export const FAQ_ITEMS = [
    {
        q: "What is the Indian Heritage Cultural Centre (IHCC)?",
        a: "IHCC is an Indian heritage museum, gallery and cultural centre at 57 Lebuh Pantai in George Town, Penang. It preserves and presents Indian heritage through historic collections, rare artefacts, vintage collectibles and immersive cultural experiences.",
    },
    {
        q: "Where is IHCC located in Penang?",
        a: "IHCC is located at 57 Lebuh Pantai, George Town, Penang, Malaysia — inside the UNESCO World Heritage zone, a short walk from Little India and the clan jetties.",
    },
    {
        q: "Is IHCC a museum?",
        a: "Yes. IHCC is a heritage museum as well as an Indian heritage gallery and cultural centre, combining curated museum-style displays with hands-on cultural experiences such as sari dress-up and interactive learning.",
    },
    {
        q: "What can visitors see at IHCC?",
        a: "Visitors can see heritage artefacts, Tanjore paintings, vintage scooters and two-wheelers, mud statues, tin toys, Pichwai and Pattachitra art, film memorabilia, vintage technology and traditional everyday objects across seven experience zones.",
    },
    {
        q: "Is IHCC suitable for families and children?",
        a: "Yes. IHCC is designed for families, tourists, students, history lovers and culture enthusiasts, with dress-up photography, visual storytelling and an interactive Seeking & Learning Hall that children enjoy.",
    },
    {
        q: "How do I buy tickets for IHCC?",
        a: "Tickets are booked online through IHCC's official booking partner at indianheritagegalleryandculturalcentre.com, where availability is confirmed instantly. No payment is taken on ihccpenang.com.",
    },
    {
        q: "What are the opening hours of IHCC?",
        a: "IHCC is open daily from 10:00 AM to 7:00 PM. The full hosted journey takes approximately 1 hour 30 minutes and is available in English, Malay, Chinese and Indonesian.",
    },
    {
        q: "What other attractions are near IHCC in George Town?",
        a: "IHCC sits within George Town's UNESCO heritage zone, close to Little India, the Kapitan Keling Mosque, the Goddess of Mercy Temple, the clan jetties, Pinang Peranakan Mansion and the city's famous street art.",
    },
];

export const scrollToId = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
